// extracted by mini-css-extract-plugin
export default {"comment":"SpecificPricePopover_comment__uWi93"};